<template>
  <div class="mapInfo father-module flex flex-v">
    <div class="title-module">
      <img
        src="@/assets/image/layout/mod-title.png"
        alt=""
        class="title-module-img"
      />
      设施详情
    </div>
    <div class="flex-1 mod-bd">
      <div>桥梁名称：{{ infowData.bridgeName }}</div>
      <div>
        桥梁简介：{{ infowData.introduce ? infowData.introduce : '暂无介绍' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeqingBridgeAndTunnelMapInfo',
  props: ['infowData'],
  data() {
    return {}
  },

  mounted() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
.mapInfo {
  width: 300px;
  // height: 351px;
  // background: rgba(25, 58, 127, 0.8);
  // border-radius: 10px;
  // border: 1px solid #33b4f0;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
  .mod-bd {
    padding: 20px;
  }
}
</style>
